import { render, staticRenderFns } from "./makeNotificationAsRead.vue?vue&type=template&id=8fa2092a"
import script from "./makeNotificationAsRead.vue?vue&type=script&lang=js"
export * from "./makeNotificationAsRead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports